import { render, staticRenderFns } from "./veStuHealthReplyEdit.vue?vue&type=template&id=70e95250&scoped=true"
import script from "./veStuHealthReplyEdit.vue?vue&type=script&lang=js"
export * from "./veStuHealthReplyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e95250",
  null
  
)

export default component.exports